var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.575 11.44C20.575 14.3229 18.2379 16.66 15.355 16.66C12.4721 16.66 10.135 14.3229 10.135 11.44C10.135 8.55707 12.4721 6.22 15.355 6.22C18.2379 6.22 20.575 8.55707 20.575 11.44Z",
    fill: "#41197F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.355 0.75C7.28888 0.75 0.75 7.28888 0.75 15.355C0.75 23.4211 7.28888 29.96 15.355 29.96C23.4211 29.96 29.96 23.4211 29.96 15.355C29.96 7.28888 23.4211 0.75 15.355 0.75ZM15.4392 17.715C11.6671 17.715 8.30166 19.4564 6.10314 22.1782C4.69332 20.2698 3.86 17.91 3.86 15.355C3.86 9.00649 9.00649 3.86 15.355 3.86C21.7036 3.86 26.85 9.00649 26.85 15.355C26.85 17.8618 26.0479 20.1805 24.6862 22.0694C22.4865 19.4101 19.1607 17.715 15.4392 17.715Z",
    fill: "#41197F",
    stroke: "#41197F",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.2513db92785ecef3caba85c3b1578f08.svg";
export { ForwardRef as ReactComponent };